import { Card, Row } from "antd";
import { DisbursementsList } from "./DisbursementsList";
import { Fees } from "./Fees";
import { BalanceDetails } from "./BalanceDetails";
import { PaymentInfo } from "./PaymentInfo";

export type PaymentDetailsProps = {
  paymentRecord: any;
  accountRoleInfo: any;
};

export const PaymentDetails = ({
  paymentRecord,
  accountRoleInfo,
}: PaymentDetailsProps) => {
  return (
    <>
      <Row className="justify-center w-100 py-2 overflow-y-hidden">
        <Card className="ph-card-container mx-4 h-100 overflow-y-auto">
          <PaymentInfo
            paymentRecord={paymentRecord}
            accountRoleInfo={accountRoleInfo}
          />
        </Card>
        <Card className="ph-card-container mx-4 h-100 overflow-y-auto mt-2">
          <DisbursementsList
            paymentRecord={paymentRecord}
            accountRoleInfo={accountRoleInfo}
          />
          <Fees
            paymentRecord={paymentRecord}
            accountRoleInfo={accountRoleInfo}
          />
        </Card>
        <Card className="ph-card-container mx-4 h-100 overflow-y-auto mt-2">
          <BalanceDetails
            paymentRecord={paymentRecord}
            accountRoleInfo={accountRoleInfo}
          />
        </Card>
      </Row>
    </>
  );
};
